var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 16.75C11.082 16.75 11.8477 15.9844 11.8477 15H8.375C8.375 15.9844 9.14062 16.75 10.125 16.75ZM16.0039 12.6758C15.4844 12.1016 14.4727 11.2539 14.4727 8.4375C14.4727 6.33203 12.9961 4.63672 10.9727 4.19922V3.625C10.9727 3.16016 10.5898 2.75 10.125 2.75C9.63281 2.75 9.25 3.16016 9.25 3.625V4.19922C7.22656 4.63672 5.75 6.33203 5.75 8.4375C5.75 11.2539 4.73828 12.1016 4.21875 12.6758C4.05469 12.8398 3.97266 13.0586 4 13.25C4 13.7148 4.32812 14.125 4.875 14.125H15.3477C15.8945 14.125 16.2227 13.7148 16.25 13.25C16.25 13.0586 16.168 12.8398 16.0039 12.6758Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7C14.8807 7 16 5.88071 16 4.5C16 3.11929 14.8807 2 13.5 2C12.1193 2 11 3.11929 11 4.5C11 5.88071 12.1193 7 13.5 7Z",
    fill: "#FF3333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/NotificationBell.740b9a23fea7f4edc9adf5c0f4489f2a.svg";
export { ForwardRef as ReactComponent };